import React from "react";
import { Box } from "@mui/material";

export default function CenterLayout({ children, additionalSx }) {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                p: 2,
                ...additionalSx,
            }}
        >
            <Box
                sx={{
                    width: 600,
                    maxWidth: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                {children}
            </Box>
        </Box>
    );
}
